import React from 'react';

import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { Typography } from '@material-ui/core';

import LegendCircle from './CircleRow';

import { ICirclesGroup } from '../../../redux/layers/layerTypes';

type CircleGroupProps = {
  style: ICirclesGroup;
};

function CircleGroup({ style }: CircleGroupProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {style.title && (
        <Typography
          className={classes.title}
          color="textPrimary"
          variant="subtitle2">
          {style.title}
        </Typography>
      )}
      {style.circles &&
        style.circles.map((circle, idx) => (
          <LegendCircle key={idx} style={circle} />
        ))}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&> :not(:last-child)': {
        marginBottom: 5
      }
    },
    title: {
      fontSize: 11
    }
  })
);

export default CircleGroup;
